import { Component, OnInit } from '@angular/core';
import { UserService } from '../services/user/user.service';
import { Router } from '@angular/router';
import { HttpErrorResponse } from '@angular/common/http';
import { DataSharingService } from '../auth/data-sharing.service';

@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.css']
})
export class DashboardComponent implements OnInit {

  //userClaims: any;
  currentUserData: any;

  isUserLoggedIn: boolean;
  isUserAdmin: boolean;
  isUserEmployee: boolean;
  isUserVendor: boolean;
  isUserHr: boolean;

  constructor(private router: Router, private userService: UserService,
    private dataSharingService: DataSharingService) {

    this.dataSharingService.isUserLoggedIn.subscribe(
      value => {
        this.isUserLoggedIn = value;
      });

    this.userService.isUserAdmin.subscribe(
      value => {
        this.isUserAdmin = value;
      });

    this.userService.isUserEmployee.subscribe(
      value => {
        this.isUserEmployee = value;
      });

    this.userService.isUserVendor.subscribe(
      value => {
        this.isUserVendor = value;
      });

    this.userService.isUserHr.subscribe(
      value => {
        this.isUserHr = value;
      });
  }

  ngOnInit() {

    // this.userService.getUserClaims().subscribe((data: any) => {
    //   this.userClaims = data;
    // });

    //code for getting current user data
    this.userService.currentUser.subscribe(
      (userdata) => {
        this.currentUserData = userdata;
      }
    );



  }

  Logout() {
    //localStorage.removeItem("userToken");
    this.userService.purgeAuth();
    this.router.navigate(['/home']);
  }

}
